<template>
  <div time="1561111721183" v-if="show_body">
    <!-- 新助教 -->
    <div v-if="!tutor.is_tutor || sele_show">
      <!-- 有提交表单 -->
      <div v-if="tutor.is_reply || sele_show">
        <!-- <div class="mt40 pd35 cart-public bgWhite">
          <div>
            <p class="text-danger text-bold">嗨，关注到这条招募的你一定是一个能量很高又有好奇心的人，不仅希望自己变厉害，也愿意帮助他人变更好，猜对了吗？</p>
            <p class="mt40">欢迎你申请成为PBL学习促动师，在个人战略课的项目中<span class="text-danger">获得两种能力：</span></p>
            <div class="list-ol">
              <p class="text">项目式学习的组织能力</p>
              <p class="text">学习促动师的专业能力</p>
            </div>
            <p>「个人战略课」会于在<span class="text-danger">每月第一周的周三</span>正式启动，进行大概5个星期，在次月中旬结束。 </p>
            <p class="mt38">每期助教培训工作会在<span class="text-danger">当期开课前十天</span>开启，请您注意协调时间，参与助教培训事宜，以及助教工作。</p>
          </div>
        </div> -->
        <!--  -->
        <!-- <div class="mt40 pd35 cart-public bgWhite">
          <div>
            <h2 class="text-danger">【招募要求】</h2>
            <p class="cart-p">希望你符合以下要求中的至少一项：</p>
            <div class="list-ol">
              <p class="text">完整学习过「个人战略课」，被教练推荐的优秀学员</p>
              <p class="text">有「个人战略课」助教经验，且表现优秀</p>
              <p class="text">有生涯培训或咨询的专业背景</p>
              <p class="text">教育行业、互联网、人力资源、心里领域优先。</p>
            </div>
          </div>
        </div> -->
        <!--  -->
        <!--  <div class="mt40 pd35 cart-public bgWhite">
          <div>
            <h2 class="text-danger">【工作内容和时间】</h2>
            <div class="list-ol mt40">
              <p class="text">平均每周投入约 7 小时带领小组（7-8 人小组）完成项目学习，在保持小组任务整体达成率和出勤率的基础之上，帮助学员提升学习动力，促进学习效果。</p>
              <p class="text">涉及的工作包含，小组组建、组织小组线上语音讨论、学员答疑、作业点评、小组考勤、优秀学员推荐、参与产品反馈。</p>
              <p class="text">小组线上语音讨论为每周 3、周 6 晚上的固定时间，需要助教全程参与和引导，至少 8 次线上语音讨论，请务必预留时间。</p>
            </div>
            <p class="mt40">温馨提醒：项目前两周投入时间会相对较多，随着小组平稳运转，助教的投入会相应减少，请知悉。</p>
          </div>
        </div> -->
        <!--  -->
        <!--  <div class="mt40 pd35 cart-public bgWhite">
          <div>
            <h2 class="text-danger">【助教回馈】</h2>
            <p class="mt40 text lin03">2019年4月-10月期间，累计担任助教2次以上，任务达成和出勤率达成100%，助教满意度评分9分以上，可以更优惠的价格报名生涯规划基础班，通过学习专业的生涯规划技能，更专业的助人助己。</p>
          </div>
        </div> -->
        <!-- 内容  -->
        <div class="mt40 pd35 cart-public">
          <!-- <p class="text-danger text-bold">如果你满足以上条件，且有意愿成为个人战略课的PBL学习促动师，请填写报名表单。并添加班主任微信参加培训事宜。</p> -->
          <div class="cart-public-new">
            <h1>欢迎你申请成为PBL学习促动师！</h1>
            <p>以下是为个人战略课/自我探索课助教个人信息收集内容，如申请请先加相关工作人员微信了解当期助教招募详情!（微信：czplan09，加好友请备注：申请个战课/自我探索课X期助教）</p>
          </div>
          <div class="mt40">
            <van-cell-group class="grouping">
              <van-field placeholder="请填写你的姓名" v-model="obj.fullname" label="姓名" />
            </van-cell-group>
            <van-cell-group class="grouping">
              <van-field @blur="testMobile" placeholder="请填写你的手机" v-model="obj.mobile" label="手机" />
            </van-cell-group>
            <van-cell-group class="grouping">
              <van-field placeholder="请填写你的微信昵称" v-model="obj.nickname" label="微信昵称" />
            </van-cell-group>
            <van-cell-group class="grouping">
              <van-field placeholder="请填写你的微信号" v-model="obj.wechat" label="微信号" />
            </van-cell-group>
            <!-- 对标人物照片 -->
            <div class="pj-task-group clearfix">
              <h3 style="line-height: normal;">微信二维码</h3>
              <div class="upload-img">
                <a href="javascript:;" @click="uploadImgHandle('wechat_qrcode')">
                  <img :src="obj.wechat_qrcode" />
                </a>
                <p class="xs-span">用于学员分组后添加助教微信 请选择上传文件，限制20MB以内</p>
              </div>
            </div>
            <!-- 对标人物照片 -->
            <div class="pj-task-group clearfix">
              <h3 style="line-height: normal;">个人头像</h3>
              <div class="upload-img clearfix pr" style="height: 100%;">
                <a href="javascript:;" @click="uploadImgHandle('head_img')">
                  <img :src="obj.head_img" />
                </a>
                <p class="xs-span">个人形象照为佳，背景干净的生活照也可， 用于做助教海报。 请选择上传文件，限制20MB以内</p>
              </div>
            </div>
            <!--        <van-cell-group class="grouping label-noraml">
          <van-field placeholder="请输入一句话介绍自己" v-model="obj.describe" label="一句话介绍" />
        </van-cell-group> -->
            <div class="mt20 diy-from">
              <div class="diy-label">
                <p>职业背景</p>
                <p style="color: #ccc;font-size: 12px;line-height: 18px;">(最大字数40)</p>
              </div>
              <div class="diy-con">
                <div>
                  <van-cell-group class="grouping">
                    <van-field @input="changeInput($event, 'describe', 40)" placeholder="例如：游走在传统行业和互联网行业的运营人" v-model="obj.describe" />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <!--        <van-cell-group class="grouping label-noraml rich_text task-textarea-title">
          <van-field placeholder="请输入三个标签" type="textarea" v-model="obj.keyword " label="三个关键词标签" />
        </van-cell-group> -->
            <div class="mt20 diy-from">
              <div class="diy-label">
                <p>个人标签</p>
                <p style="color: #ccc;font-size: 12px;line-height: 18px;">(每个标签的最大字数20)</p>
              </div>
              <div class="diy-con">
                <div>
                  <van-cell-group class="grouping">
                    <van-field @input="changeInput($event, 'keyword1', 20)" placeholder="例如：1、温暖且有力量的生涯咨询师" v-model="obj.keyword1" />
                  </van-cell-group>
                </div>
                <div class="mt20">
                  <van-cell-group class="grouping">
                    <van-field @input="changeInput($event, 'keyword2', 20)" placeholder="2、具有可复制领导力的管理者" v-model="obj.keyword2" />
                  </van-cell-group>
                </div>
                <div class="mt20">
                  <van-cell-group class="grouping">
                    <van-field @input="changeInput($event, 'keyword3', 20)" placeholder="3、润物细无声的个人成长教练" v-model="obj.keyword3" />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <van-cell-group class="grouping">
              <van-field placeholder="请选择工作年限" v-model="obj.work_age" label="工作年限" @click="pickerType({key: 'work_age', index: false}, poperID.workage)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
            <van-cell-group class="grouping">
              <van-field placeholder="请选择从事行业" v-model="obj.career" label="所处行业" @click="pickerType({key: 'career', index: true}, poperID.trade_group)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
            <van-cell-group class="grouping">
              <van-field placeholder="请选择岗位职级" v-model="obj.job_title" label="岗位职级" @click="pickerType({key: 'job_title', index: true}, poperID.job_title)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
            <van-cell-group class="grouping">
              <van-field placeholder="请选择岗位职能" v-model="obj.job_office" label="岗位职能" @click="pickerType({key: 'job_office', index: true}, poperID.profession_group)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
          </div>
        </div>
        <div class="mt40 pd35 cart-public mt40_spe">
          <div>
            <!-- <p>{{selectArr1.key}}</p>
            <div class="mt20">
              <p v-for="(item, index) in selectArr1.list" @click="selectRadio(item, selectArr1, true, index)" :class="[obj.subtitle === item ? 'DIY-radio-active' : '', 'DIY-radio']">{{item}}</p>
            </div>
            <div v-if="show_index === 0" class="mt40">
              <van-cell-group class="grouping label-noraml">
                <van-field v-model="obj['带领的小组是']" label="带领的小组是" />
              </van-cell-group>
            </div>
            <div v-if="show_index === 2" class="mt40">
              <van-cell-group class="grouping label-noraml">
                <van-field v-model="obj['所在班级小组']" label="所在班级小组" />
              </van-cell-group>
            </div>
            <div v-if="typeof show_index !== 'boolean'">
              <div class="mt40">
                <span class="blank-blod">{{selectArr3.key}}</span>
                <span class="text-danger">开营日起，连续5周，每周3周6晚（具体时间可自行调整）的小组线上语音讨论为固定时间，请务必预留时间。如果本期时间不允许，你可以在“其他”里填写自己大概可以的时间，如果条件符合，我们到时会再邀请你</span>
              </div>
              <div class="mt20"> -->
            <!--  -->
            <!-- <p v-for="item in selectArr3.list" @click="selectRadio(item, selectArr3)" :class="[selectArr3.value === item ? 'DIY-radio-active' : '', 'DIY-radio']">{{item}}</p> -->
            <!--  -->
            <!-- <div v-if="selectArr3.other" @click="selectRadio('其他', selectArr3)" :class="[selectArr3.value === '其他' ? 'DIY-radio-active' : '', 'DIY-radio DIY-redio-other mt20']">
                  <span class="draw_close">其他</span>
                  <div class="pr">
                    <van-cell-group class="grouping">
                      <van-field v-model="selectArr3.otherVal" />
                    </van-cell-group>
                  </div>
                </div>
              </div>
            </div> -->
            <!--  -->
            <!-- <div v-if="show_index === 1" class="mt40">
              <p class="blank-blod">{{selectArr[0].key}}</p>
              <div class="mt20">

                <p v-for="item in selectArr[0].list" @click="changeCheckbox(item, selectArr[0])" :class="[selectArr[0].value[item] ? 'DIY-checkbox-active' : '', 'DIY-checkbox']"><span class="state-ico"><img src="@a/press.png" alt="" /></span>{{item}}</p>

                <div v-if="selectArr[0].other" :class="[selectArr[0].value['其他'] ? 'DIY-checkbox-active' : '', 'DIY-checkbox DIY-checkbox-other mt20']">
                  <span class="state-ico"><img src="@a/press.png" alt="" /></span>
                  <span @click="changeCheckbox('其他', selectArr[0])" class="draw_close">其他</span>
                  <div class="pr">
                    <van-cell-group class="grouping">
                      <van-field v-model="selectArr[0].otherVal" />
                    </van-cell-group>
                  </div>
                </div>
              </div>
            </div> -->
            <!--  -->
            <!-- <div v-if="show_index === 1 || show_index === 2" class="mt40">
              <p class="blank-blod">{{selectArr[1].key}}</p>
              <div class="mt20">

                <p v-for="item in selectArr[1].list" @click="changeCheckbox(item, selectArr[1])" :class="[selectArr[1].value[item] ? 'DIY-checkbox-active' : '', 'DIY-checkbox']"><span class="state-ico"><img src="@a/press.png" alt="" /></span>{{item}}</p>

                <div v-if="selectArr[1].other" :class="[selectArr[1].value['其他']  ? 'DIY-checkbox-active' : '', 'DIY-checkbox DIY-checkbox-other mt20']">
                  <span class="state-ico"><img src="@a/press.png" alt="" /></span>
                  <span @click="changeCheckbox('其他', selectArr[1])" class="draw_close">其他</span>
                  <div class="pr">
                    <van-cell-group class="grouping">
                      <van-field v-model="selectArr[1].otherVal" />
                    </van-cell-group>
                  </div>
                </div>
              </div>
            </div> -->
            <!--  -->
            <!-- <div v-if="show_index === 1 || show_index === 2" class="mt40">
              <p class="blank-blod">{{selectArr[2].key}}</p>
              <div class="mt20">

                <p v-for="item in selectArr[2].list" @click="changeCheckbox(item, selectArr[2])" :class="[selectArr[2].value[item] ? 'DIY-checkbox-active' : '', 'DIY-checkbox']"><span class="state-ico"><img src="@a/press.png" alt="" /></span>{{item}}</p>

                <div v-if="selectArr[2].other" :class="[selectArr[2].value['其他']  ? 'DIY-checkbox-active' : '', 'DIY-checkbox DIY-checkbox-other mt20']">
                  <span class="state-ico"><img src="@a/press.png" alt="" /></span>
                  <span @click="changeCheckbox('其他', selectArr[2])" class="draw_close">其他</span>
                  <div class="pr">
                    <van-cell-group class="grouping">
                      <van-field v-model="selectArr[2].otherVal" />
                    </van-cell-group>
                  </div>
                </div>
              </div>
            </div> -->
            <!--  -->
            <div class="mt40 mt40_spe">
              <p class="blank-blod">{{selectArr2.key}}</p>
              <div v-for="(item,index) in selectArr2.list" :key="index" :class="['old_turo_div',index==selectArr2.list.length-1?'last':'']">
                <h3>{{item.name}}</h3>
                <div class="mt20">
                  <p @click="changeCidVal(item, item.selected)" :style="{color: !item.selected ? '#ccc' : '#000'}" :class="[obj.cid[item.key]  ? 'DIY-checkbox-active' : '', 'DIY-checkbox']"><span class="state-ico"><img src="@a/press.png" alt="" /></span>{{item.val}}<span class="xs-font" v-if="!item.selected">(本期次助教已截止申请)</span></p>
                </div>
              </div>
            </div>
            <!--  -->
            <div class="mt40">
              <div @click="submitData" :class="[isAllow() ? 'btn-active' : '', 'btn-submit']">提交</div>
            </div>
          </div>
        </div>
        <!-- 弹出选择 -->
        <van-popup v-model="picker_show" position="bottom">
          <van-picker show-toolbar :columns="targetColumns" @cancel="pickerCancel" @confirm="pickerConfirm" />
        </van-popup>
      </div>
      <!-- 没有申请资格 -->
      <div class="text-center tc" v-else>
        <p class="text-danger p1">抱歉，由于您参与的近期课程尚未结营/不是
          <br/>PBL课程学员，未能获取本期助教申请资格！</p>
        <p class="line30">如有疑问，请直接扫描下方二维码添加工作人员微信咨询。</p>
        <div class="mt56">
          <img src="@a/ta_askfor_result.png" alt="" />
          <p class="qr-span">(长按识别或扫描上方二维码添加)</p>
        </div>
      </div>
    </div>
    <!-- 老助教 -->
    <div v-else>
      <!-- 等待下期资格 -->
      <div class="text-center tc" v-if="!tutor.is_reply">
        <p class="text-danger p1">抱歉，由于您带领的{{tutor.bigcourse}}{{tutor.now}}课程尚未结营，暂
          <br/>不可申请成为{{tutor.bigcourse}}{{tutor.now}}助教。请耐心等待下次助
          <br/>教招募时间开放（开营前一两周），届时请积极
          <br/>报名。</p>
        <!-- <p class="line30">如有疑问，请直接扫描下方二维码添加工作人员微信咨询。</p> -->
        <div class="mt56">
          <img src="@a/ta_askfor_xp.png" alt="" />
          <!-- <p class="qr-span">(长按识别或扫描上方二维码添加)</p> -->
        </div>
      </div>
      <div class="old_turo" v-else>
        <h2>您好，由于您是往期助教，可直接跳过【资料填写】步骤，直接勾选下方的【课程期次】进行提交。<span>注意：如需修改资料，请点击</span><a @click="sele_show = true">修改资料</a><span>进行更新</span></h2>
        <h1>{{selectArr2.key}}</h1>
        <div v-for="(item,index) in selectArr2.list" :key="index" :class="['old_turo_div',index==selectArr2.list.length-1?'last':'']">
          <h3>{{item.name}}</h3>
          <div class="mt20">
            <p @click="changeCidValOld(item, item.selected)" :style="{color: !item.selected ? '#ccc' : '#000'}" :class="[old_radio[item.key]  ? 'DIY-checkbox-active' : '', 'DIY-checkbox']"><span class="state-ico"><img src="@a/press.png" alt="" /></span>{{item.val}}<span class="xs-font" v-if="!item.selected">(本期次助教已截止申请)</span></p>
          </div>
        </div>
        <div class="mt40">
          <div @click="submitDataAdd" :class="['btnn',old_radio.length>0 ? 'btn-active' : '', 'btn-submit']">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk"
import imgSrc from "@a/upload_img.png"
import { index, edit, save_tutor_qrcode} from "@/api/assistant"
import { new_savnew_user_head} from "@/api/course"
import { phoneValidation } from "@u/validation";
export default {
  data() {
      return {
        show_index: false,
        targetColumns: [],
        targetItem: false,
        picker_show: false,
        show_body: false,
        poperID: {
          workage: {},
          trade_group: {},
          profession_group: {},
          job_title: {}
        },
        obj: {
          cid: {}, // 期数
          fullname: '', // 姓名
          wechat: '', // 微信
          mobile: '', // 手机
          career: '', // 行业
          job_office: '', // 职能
          job_title: '', // 职位
          work_age: '', // 工作年限
          head_img: '' || imgSrc, // 头像
          wechat_qrcode: '' || imgSrc, // 助教个人微信二维码
          describe: '', // 一句话描述
          keyword1: '', // 关键词
          keyword2: '', // 关键词
          keyword3: '', // 关键词
          subtitle: '', // 曾经的选择内容
          subcontent: '', // 曾经的字内容，以json串传参 标题title 选择内容content
        },
        selectArr1: {
          key: "你曾经...",
          type: 'radio',
          list: [
            '担任过个人战略课助教？',
            '有生涯咨询师背景，但没担任过个人战略课 助教？',
            '往期个人战略课学员？'
          ],
          value: '担任过个人战略课助教？',
          other: false
        },
        selectArr2: {
          key: "选择申请的课程与期次",
          type: 'checkbox',
          config: {
            maxSelectLength: false
          },
          value: {},
          list: [],
          otherVal: '',
          other: false
        },
        selectArr3: {
          key: "如果成为学习促动师，需要你在开营当周开始，至次月中旬这段时间参与进项目，你的时间安排情况如何？",
          type: 'radio',
          list: [
            '时间充裕，且有意愿全程参与', '时间比较紧张，不过愿意预留时间全程参与',
            '想参与，但是时间不太能保证，出现临时状 况的可能性较大',
            '没有时间，但是想参加，想了解后续课程的 时间安排'
          ],
          value: '',
          otherVal: '',
          other: true
        },
        selectArr: [
          // 0
          {
            key: "你的生涯或者个人战略相关学习与实战经验",
            type: 'checkbox',
            config: {
              maxSelectLength: false
            },
            list: [
              '参加完了生涯规划师基础班/认证班',
              '我完成了「个人战略课」的全部项目学习',
              '我正在进行「个人战略课」的学习',
              '我做过「个人战略课」的教练或助教',
              '参加了咨询师实战班',
              '有超过20例【免费】咨询经验',
              '有超过10例【免费】咨询经验',
              '有超过2小时的生涯相关培训经验',
              '我专职从事生涯领域的工作/创业'
            ],
            value: {},
            otherVal: '',
            other: true
          },
          // 1
          {
            key: "如果能成为助教，你最看重（选1-2项）",
            type: 'checkbox',
            config: {
              maxSelectLength: 2,
              selectLength: 0
            },
            list: [
              '未来有参与研发、教学的机会',
              '提升自己的个人品牌',
              '能够真正帮助到别人',
              '能认识更多行业高手',
              '能有物质回报',
              '能以更低的费用参加生涯规划类的线下培训',
            ],
            value: {},
            otherVal: '',
            other: true
          },
          // 2
          {
            key: "如果能成为助教，你认为你的特长是（选1-2项）",
            type: 'checkbox',
            config: {
              maxSelectLength: 2,
              selectLength: 0
            },
            list: [
              '为学员提供课程和作业相关的答疑解惑',
              '组织能力，能保证小组气氛',
              '领导能力，能带领小组成员持续行动',
              '引导和提问技巧，能组织一场效果很好的讨论',
              '激励或者督促大家更好的学习和互动',
              '收集信息，给课程本身的优化迭代给反馈和 建议',
              '帮助老师讲课或者主持',
              '我能一对一的支持别人',
              '批改点评作业，给有价值的建议',
            ],
            value: {},
            otherVal: '',
            other: true
          }
        ],
        tutor: {},
        old_radio: [],
        sele_show: false,
        course: {},
        bid:null
      }
    },
    methods: {
      testMobile() {
        // let isCorr = /^[1][3,4,5,7,8][0-9]{9}$/.test();
        if (!phoneValidation(this.obj.mobile)) {
          this.$toast(`您的手机格式错误！`);
        }
      },
      changeInput(ev, key, maxLen) {
        let tarLen = ev.length;
        if (tarLen > maxLen) {
          this.obj[key] = ev.slice(0, maxLen);
        }
      },
      isAllow() {
        if (
          (JSON.stringify(this.obj.cid) !== '{}') &&
          this.obj.fullname &&
          this.obj.wechat &&
          this.obj.mobile &&
          phoneValidation(this.obj.mobile) &&
          this.obj.career &&
          this.obj.job_office &&
          this.obj.job_title &&
          this.obj.work_age &&
          this.obj.head_img &&
          this.obj.wechat_qrcode &&
          this.obj.describe &&
          this.obj.keyword1 &&
          this.obj.keyword2 &&
          this.obj.keyword3
        ) {
          return true
        }
        return false
          // if (this.show_index === 0) {
          //   if (
          //     (JSON.stringify(this.obj.cid) !== '{}') &&
          //     this.obj.fullname &&
          //     this.obj.wechat &&
          //     this.obj.mobile &&
          //     phoneValidation(this.obj.mobile) &&
          //     this.obj.career &&
          //     this.obj.job_office &&
          //     this.obj.job_title &&
          //     this.obj.work_age &&
          //     this.obj.head_img &&
          //     this.obj['带领的小组是'] &&
          //     this.obj.wechat_qrcode &&
          //     this.obj.describe &&
          //     this.obj.keyword1 &&
          //     this.obj.keyword2 &&
          //     this.obj.keyword3 &&
          //     this.obj.subtitle
          //     this.selectArr1.value !== '' &&
          //     this.selectArr3.value !== ''
          //   ) {
          //     return true
          //   }
          //   return false
          // } else if (this.show_index === 1) {
          //   if (
          //     (JSON.stringify(this.obj.cid) !== '{}') &&
          //     this.obj.fullname &&
          //     this.obj.wechat &&
          //     this.obj.mobile &&
          //     phoneValidation(this.obj.mobile) &&
          //     this.obj.career &&
          //     this.obj.job_office &&
          //     this.obj.job_title &&
          //     this.obj.work_age &&
          //     this.obj.head_img &&
          //     this.obj.wechat_qrcode &&
          //     this.obj.describe &&
          //     this.obj.keyword1 &&
          //     this.obj.keyword2 &&
          //     this.obj.keyword3 &&
          //     this.obj.subtitle
          //     this.isAllowSelects() &&
          //     this.selectArr1.value !== '' &&
          //     this.selectArr3.value !== ''
          //   ) {
          //     return true
          //   }
          //   return false
          // } else if (this.show_index == 2) {
          //   if (JSON.stringify(this.obj.cid) !== '{}' &&
          //     this.obj.fullname &&
          //     this.obj.wechat &&
          //     this.obj.mobile &&
          //     phoneValidation(this.obj.mobile) &&
          //     this.obj.career &&
          //     this.obj.job_office &&
          //     this.obj.job_title &&
          //     this.obj.work_age &&
          //     this.obj.head_img &&
          //     this.obj.wechat_qrcode &&
          //     this.obj['所在班级小组'] &&
          //     this.obj.describe &&
          //     this.obj.keyword1 &&
          //     this.obj.keyword2 &&
          //     this.obj.keyword3 &&
          //     this.obj.subtitle
          //     this.isAllowSelects() &&
          //     this.selectArr1.value !== '' &&
          //     this.selectArr3.value !== ''
          //   ) {
          //     return true
          //   }
          //   return false
          // }
      },
      isAllowSelects() {
        for (let arg of this.selectArr) {
          if (arg.type === 'checkbox' && JSON.stringify(arg.value) === '{}') {
            return false
          }
        }
        return true
      },
      createData() {
        let json = [];
        // > 0 选择
        if (this.show_index > 0) {
          for (let arg of this.selectArr) {
            if (arg.type === 'radio') {
              json[arg.key] = arg.value;
              if (arg.value === '其他' && arg.other) {
                // json[arg.key] = arg.otherVal;
                json.push({
                  title: arg.key,
                  content: arg.otherVal
                })
              }
            }
            if (arg.type === 'checkbox' && this.show_index > 0) {
              let arr = [];
              for (let attr in arg.value) {
                if (attr === '其他') {
                  arr.push(arg.otherVal);
                } else {
                  arr.push(attr);
                }
              }
              // json[arg.key] = JSON.stringify(arr)
              json.push({
                title: arg.key,
                content: JSON.stringify(arr)
              })
            }
          }
        }
        // 如果成为促进师
        // json[this.selectArr3.key] = (this.selectArr3.value === '其他') ? this.selectArr3.otherVal : this.selectArr3.value;
        json.push({
            title: this.selectArr3.key,
            content: (this.selectArr3.value === '其他') ? this.selectArr3.otherVal : this.selectArr3.value
          })
          // 带领小组
        if (this.show_index === 0) {
          // json["带领的小组是"] = this.obj['带领的小组是'];
          json.push({
            title: "带领的小组是",
            content: this.obj['带领的小组是']
          })
        }
        // 所在小组
        if (this.show_index === 2) {
          // json["所在班级小组"] = this.obj['所在班级小组'];
          json.push({
            title: "所在班级小组",
            content: this.obj['所在班级小组']
          })
        }
        return {
          // 最后一个双选
          cid: (Object.keys(this.obj.cid)).toString(),
          fullname: this.obj.fullname,
          nickname: this.obj.nickname,
          wechat: this.obj.wechat,
          mobile: this.obj.mobile,
          career: this.poperID.trade_group[this.obj.career],
          job_office: this.poperID.profession_group[this.obj.job_office],
          job_title: this.poperID.job_title[this.obj.job_title],
          work_age: this.obj.work_age,
          head_img: this.obj.head_img,
          wechat_qrcode: this.obj.wechat_qrcode,
          describe: this.obj.describe,
          keyword: this.obj.keyword1 + '&' + this.obj.keyword2 + '&' + this.obj.keyword3,
          subtitle: this.obj.subtitle,
          subcontent: JSON.stringify(json)
        }
      },
      submitData() {
        if (!this.isAllow()) {
          return
        }
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        // 通过测试，去数据
        let subData = this.createData();
        edit(subData)
          .then((data) => {
            this.$toast.clear();
            if (data.msg === '数据存入成功！') {
              this.$router.push('/ta_askfor_result')
            } else {
              this.$toast(data.msg);
            }
          })
      },
      submitDataAdd() {
        if (this.old_radio.length == 0) {
          return
        }
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        // 通过测试，去数据
        let result = this.data.result;
        let subData = {
          cid: (Object.keys(this.old_radio)).toString(),
          fullname: result.fullname,
          nickname: result.nickname,
          wechat: result.wechat,
          mobile: result.mobile,
          career: result.career,
          job_office: result.job_office,
          job_title: result.job_title,
          work_age: result.work_age,
          head_img: result.head_img,
          wechat_qrcode: result.wechat_qrcode,
          describe: result.describe,
          keyword: result.keyword,
          subtitle: result.subtitle,
          subcontent: result.subcontent
        };
        edit(subData)
          .then((data) => {
            this.$toast.clear();
            if (data.msg === '数据存入成功！') {
              this.$router.push({
                path:'/ta_askfor_result',
                query:{
                  bid:this.bid
                }
              })
            } else {
              this.$toast(data.msg);
            }
          })
      },
      itemChangeLen(bool, item) {
        if (bool) {
          item.config.selectLength++;
        } else {
          item.config.selectLength--;
        }
      },
      changeCidValOld(item, bool) {
        let cidKey = item.key;
        if (!bool) {
          return
        }
        if (this.old_radio[cidKey]) {
          delete this.old_radio[cidKey];
        } else {
          this.old_radio[cidKey] = true;
        }
        this.$forceUpdate();
      },
      changeCidVal(item, bool) {
        let cidKey = item.key;
        if (!bool) {
          return
        }
        if (this.obj.cid[cidKey]) {
          delete this.obj.cid[cidKey];
        } else {
          this.obj.cid[cidKey] = true;
        }
        this.bid=item.pid;
        this.$forceUpdate();
      },
      changeCheckbox(val, curData) {
        if (curData.value[val]) {
          // curData.value[val] = false;
          delete curData.value[val]
          this.itemChangeLen(false, curData);
        } else {
          // 是否限制勾选长度
          if (curData.config.maxSelectLength && (curData.config.selectLength === curData.config.maxSelectLength)) {
            this.$toast(`只能勾选 ${curData.config.maxSelectLength} 项内容！`);
            return
          }
          // 不限制
          this.itemChangeLen(true, curData)
          curData.value[val] = true;
        }
        this.$forceUpdate();
      },
      selectRadio(val, curData, off, index) {
        if (typeof index === 'number') {
          this.show_index = index;
        }
        if (!off) {
          curData.value = val;
        } else {
          this.obj['subtitle'] = val;
        }
        this.$forceUpdate();
      },
      pickerType(target, tarQueue) {
        this.targetItem = target;
        this.targetColumns = Object.keys(tarQueue);
        this.picker_show = true;
      },
      pickerCancel() {
        this.picker_show = false;
      },
      pickerConfirm(val) {
        let isStoraIndex = this.targetItem.index;
        let tarObjKey = this.targetItem.key;
        this.obj[tarObjKey] = val;
        this.picker_show = false;
      },
      // 上传图片
      uploadImgHandle(key) {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res) => {
                // this.serverId = res.serverId;
                console.log(res.serverId);
                this.imgSave(key, res.serverId);
              }
            });
          }
        });
      },
      imgSave(key, serverId) {
        new_savnew_user_head({
            server_id: serverId
          })
          .then(data => {
            this.obj[key] = data.image_url;
          })
          .catch(err => {
            alert(err);
          });
      },
      pullData() {
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        // ajax
        index()
          .then(data => {
            this.$toast.clear();
            this.tutor = data.tutor;
            this.data = data;
            if (!data.course) {
              this.$router.push('/person');
              return
            }
            // 期
            let arr = [];
            for (let arg of data.course) {
              let IDkey = `${arg.course_begintime}-${arg.course_endtime}`;
              arr.push({
                key: arg.id,
                selected: arg.selected,
                val: IDkey,
                name: arg.name,
                pid: arg.pid
              });
            }
            this.selectArr2.list = arr;
            // 年限
            for (let arg of data.workage) {
              this.poperID.workage[arg] = true;
            }
            // 行业
            for (let arg of data.trade_group) {
              this.poperID.trade_group[arg[1]] = arg[0];
            }
            // 岗位职能
            for (let arg of data.profession_group) {
              this.poperID.profession_group[arg[1]] = arg[0];
            }
            // 岗位职级
            for (let arg of data.job_title) {
              this.poperID.job_title[arg[1]] = arg[0];
            }

            // 存入已经填的
            if (data.result && data.result.subcontent) {
              this.obj.mobile = data.result.mobile;
              this.obj.fullname = data.result.fullname;
              this.obj.head_img = data.result.head_img;
              this.obj.subtitle = data.result.subtitle;
              this.obj.wechat = data.result.wechat;
              this.obj.wechat_qrcode = data.result.wechat_qrcode;
              this.obj.work_age = data.result.work_age;
              this.obj.nickname = data.result.nickname;
              if (data.result.keyword) {
                this.obj.keyword1 = data.result.keyword.split('&')[0] || '';
                this.obj.keyword2 = data.result.keyword.split('&')[1] || '';
                this.obj.keyword3 = data.result.keyword.split('&')[2] || '';
              }
              this.obj.describe = data.result.describe;

              // 你曾经
              for (let [index, arg] of this.selectArr1.list.entries()) {
                if (arg === data.result.subtitle) {
                  this.selectArr1.value = arg;
                  this.show_index = index;
                }
              }

              // 四个选择

              for (let attr in this.poperID.trade_group) {
                let val = this.poperID.trade_group[attr];
                if (val === data.result.career) {
                  this.obj.career = attr;
                }
              }
              for (let attr in this.poperID.job_title) {
                let val = this.poperID.job_title[attr];
                if (val === data.result.job_title) {
                  this.obj.job_title = attr;
                }
              }
              for (let attr in this.poperID.profession_group) {
                let val = this.poperID.profession_group[attr];
                if (val === data.result.job_office) {
                  this.obj.job_office = attr;
                }
              }

              // 期数
              let curCid = data.result.cid.split(',');
              for (let arg of curCid) {
                for (let arg2 of this.selectArr2.list) {
                  if (arg2.key == arg) {
                    this.obj.cid[arg2.key] = true;
                  }
                }
              }


              // 单选多选
              let parseData = JSON.parse(data.result.subcontent);

              // 数据修复
              for (let i = 0; i < parseData.length; i++) {
                if (parseData[i]['title'] == '你的生涯或者个人战略相关学习与实战经验 （可多选）') {
                  parseData[i]['title'] = '你的生涯或者个人战略相关学习与实战经验';
                }
              }

              (() => {
                let isExist = false;
                let key = this.selectArr3.key;
                let val = null;
                // let val = parseData[key];
                for (let arg of parseData) {
                  if (arg.title === key) {
                    val = arg.content;
                  }
                }
                for (let arg of this.selectArr3.list) {
                  if (arg === val) {
                    // 如果你成为促进师
                    this.selectArr3.value = arg;
                    isExist = true;
                    break;
                  }
                }
                // 未找到
                if (!isExist) {
                  this.selectArr3.value = '其他';
                  this.selectArr3.otherVal = val;
                }
              })();

              // 带领的小组
              // this.obj["带领的小组是"] = parseData["带领的小组是"];
              (() => {
                for (let arg of parseData) {
                  if (arg.title === "带领的小组是") {
                    this.obj["带领的小组是"] = arg.content;
                  }
                }
              })();

              // 所在小组
              // this.obj["所在班级小组"] = parseData["所在班级小组"];
              (() => {
                for (let arg of parseData) {
                  if (arg.title === "所在班级小组") {
                    this.obj["所在班级小组"] = arg.content;
                  }
                }
              })();

              if (this.show_index > 0) {
                let nLi = {};
                for (let arg of parseData) {
                  if (/\[/g.test(arg.content)) {
                    nLi[arg.title] = arg.content;
                  }
                }
                //
                for (let arg of this.selectArr) {
                  let key = arg.key;
                  if (!key || !nLi[key]) {
                    break;
                  }
                  if (!arg.other) {
                    // let curData = JSON.parse(parseData[key]);
                    let curData = JSON.parse(nLi[key]);
                    if (!curData) {
                      break;
                    }
                    for (let arg2 of curData) {
                      arg.value[arg2] = true;
                      if (arg.config.maxSelectLength) {
                        arg.config.selectLength++;
                      }
                    }
                  } else {
                    // let curData = JSON.parse(parseData[key]);
                    let curData = JSON.parse(nLi[key]);
                    if (!curData) {
                      break;
                    }
                    for (let arg2 of curData) {
                      let off = false;
                      for (let arg3 of arg.list) {
                        if (arg3 === arg2) {
                          arg.value[arg2] = true;
                          if (arg.config.maxSelectLength) {
                            arg.config.selectLength++;
                          }
                          off = true;
                          break;
                        }
                      }
                      if (!off) {
                        arg.value['其他'] = true;
                        arg.otherVal = arg2;
                        if (arg.config.maxSelectLength) {
                          arg.config.selectLength++;
                        }
                      }
                    }
                  }
                }
              }

            } else {

            }
            this.show_body = true;
            this.$forceUpdate();
          })

      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/taskStyle.scss";
.bgWhite {
  background: #fff;
}

p.text {
  font-size: 28px;
  line-height: 34px;
}

p.lin03 {
  line-height: 46px;
}

span.xs-font {
  font-size: 22px;
}

.cart-public {
  font-size: 32px;
  color: #333;
  line-height: 44px;
  .cart-public-new {
    width: 690px;
    height: 312px;
    background: linear-gradient(-90deg, rgba(237, 48, 90, 1), rgba(235, 80, 50, 1));
    border-radius: 12px;
    padding: 20px;
    padding-top: 40px;
    h1 {
      font-size: 32px;
      color: #fff;
    }
    p {
      font-size: 28px;
      color: #fff;
      margin-top: 40px;
      line-height: 40px;
    }
  }
  /* ol */
  .list-ol {
    margin-top: 20px;
    margin-bottom: 20px;
    p {
      padding-left: 30px;
      position: relative;
      line-height: 50px;
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background: #EB5032;
        left: 7px;
        top: 17px;
      }
    }
  }
  /* 二级标题 */
  .cart-p {
    font-size: 32px;
    color: #333;
    margin-top: 60px;
  }
}


/* 重置上传说明xs */

.xs-span {
  font-size: 20px;
  color: #999;
  line-height: normal!important;
  height: 100%;
}


/* 自定义单选 */

.DIY-radio {
  padding-left: 60px;
  position: relative;
  line-height: 44px;
  margin-top: 20px;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 2px;
    width: 38px;
    height: 38px;
    border-radius: 19px;
    border: 2px solid #ccc;
  }
}

.DIY-redio-other {
  height: 70px;
  line-height: 70px;
  margin-top: 0;
  display: flex;
  flex-direction: row;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 14px;
  }
  >span {
    display: inline-block;
  }
  >div {
    display: inline-block;
    flex: 1;
  }
}

.DIY-radio-active {
  &::after {
    background: #fff;
    width: 20px;
    height: 20px;
    border: 10px solid #EB5032;
  }
}


/* 自定义多选 */

.DIY-checkbox {
  position: relative;
  line-height: 40px;
  padding: 10px 0;
  padding-left: 60px;
  .state-ico {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 15px;
    width: 32px;
    height: 32px;
    border: 2px solid #ccc;
    border-radius: 6px;
    img {
      display: none;
    }
  }
}

.DIY-checkbox-active {
  .state-ico {
    border: none;
    img {
      max-width: 32px;
      display: block;
    }
  }
}

.DIY-checkbox-other {
  display: flex;
  >div {
    flex: 1;
  }
}


/* 自定义输入组 */

.diy-from {
  display: flex;
  flex-wrap: nowrap;
  .diy-label {
    width: 2rem;
    padding-right: 0.266667rem;
    text-align: left;
  }
  .diy-con {
    flex: 1;
  }
}


/* 提交按钮 */

.btn-submit {
  background: #ccc;
  width: 174px;
  height: 66px;
  line-height: 66px;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  border-radius: 33px;
  font-size: 34px;
}

.btn-active {
  background: #EB5032;
}


/* draw close */

.draw_close {
  margin-right: 20px;
}


/* 类 */

.mt40 {
  margin-top: 40px!important;
}

.mt40_spe {
  margin-top: 0px!important;
}

.mt20 {
  margin-top: 20px!important;
}

.mt30 {
  margin-top: 30px!important;
}

.pd35 {
  padding: 35px!important;
}

.text-danger {
  color: #EB5032;
}

.text-bold {
  font-weight: bold;
}

.blank-blod {
  font-weight: bold;
  color: #333;
}

.pt160 {
  padding-top: 160px;
}

.mt56 {
  margin-top: 40px;
  img {
    max-width: 426px;
    width: 426px;
    background: #ccc;
  }
  .qr-span {
    font-size: 28px;
    color: #999;
  }
}

.p1 {
  font-size: 32px;
}

.line30 {
  line-height: 50px;
  color: #666;
}

.text-danger {
  color: #EB5032;
}

.tc {
  padding-top: 160px;
  padding-bottom: 100px;
}

.old_turo {
  padding: 30px;
  h1 {
    color: #333;
    font-size: 32px;
    font-weight: bold;
    margin: 30px 0;
  }
  h2 {
    font-size: 32px;
    color: #333;
    span {
      color: #666;
      font-size: 24px;
    }
    a {
      color: #EB5032;
      font-size: 24px;
      text-decoration: underline;
    }
  }
}

.old_turo_div {
  padding-bottom: 40px;
  border-bottom: 2px dashed rgba(204, 204, 204, 1);
  margin-top: 40px;
  h3 {
    color: #EB5032;
    font-size: 28px;
    margin-bottom: 20px;
  }
}

.old_turo_div.last {
  border-bottom: none;
}

.btnn {
  position: fixed;
  bottom: 40px;
  left: 50%;
  margin-left: -87px;
}
</style>
<style>
.label-noraml .van-cell .van-field__label,
.grouping.label-noraml.rich_text.task-textarea-title .van-cell .van-field__label {
  line-height: normal;
  text-align: left;
}

.old_turo .radio_group {
  margin-bottom: 30px;
}

.old_turo .radio_group:last-child {
  margin-bottom: 0;
}

.old_turo .radio_group .van-radio__icon {
  height: 41px;
  line-height: 41px;
}

.old_turo .radio_group .van-radio__icon .van-icon {
  width: 41px;
  height: 41px;
  line-height: 41px;
  background: url(../../../assets/radio_.png) no-repeat top center;
  background-size: cover;
  border-color: transparent;
  background-color: transparent;
}

.old_turo .radio_group .van-radio__icon .van-icon:before {
  content: '';
}

.old_turo .radio_group .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  background-image: url(../../../assets/radio_active.png);
}

.old_turo .radio_group .van-radio__label {
  line-height: 35px;
  width: 618px;
  margin-left: 30px;
  font-size: 32px;
}

.old_turo .radio_group .van-radio__label span {
  color: #999;
  font-size: 20px;
}
</style>
